<template>
  <VModal name="delete-apikey-modal" :loading="loading">
    <template v-slot:header>
      <h2 class="o-modal__box__header">{{ $t('companySettings.developer.apikeys.delete') }}</h2>
    </template>
    <template v-slot:content>
      <p data-hj-suppress>{{ $t('companySettings.developer.apikeys.deleteWarning', { name: item.name }) }}</p>
      <VForm :onSubmit="validateForm" data-vv-scope="apikey-delete">
        <div slot="formButtons" type="left">
          <VButton
            type="outline-1"
            data-ec="delete_api_key_modal"
            data-et="cancel_button"
            @click="closeModal">
            <span>{{ $t('functional.cancel') }}</span>
          </VButton>
        </div>
        <div slot="formButtons" type="right">
          <VButton
            type="error"
            data-ec="delete_api_key_modal"
            data-et="delete_button"
            subtype="submit">
            <TrashIcon />
            <span>{{ $t('functional.delete') }}</span>
          </VButton>
        </div>
      </VForm>
    </template>
  </VModal>
</template>

<script>
import VButton from '@/components/deprecated/atoms/Button.vue';
import VForm from '@/components/deprecated/organisms/Form.vue';
import VModal from '@/components/deprecated/organisms/Modal.vue';
import { TrashIcon } from '@/components/icons/fontIcons';

export default {
  name: 'DeleteApiKeyModal',
  inject: {
    $validator: '$validator',
  },
  props: {
    item: Object,
  },
  components: {
    VButton,
    VForm,
    VModal,
    TrashIcon,
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    closeModal() {
      this.$bus.$emit('closeModal');
    },
    validateForm(scope) {
      this.$validator.validateAll(scope).then((validated) => {
        if (validated) {
          this.loading = true;
          this.$store.dispatch('apiKeys/DELETE', this.item).then(() => {
            this.$bus.$emit('renderGlobalMessage', ({ message: this.$t('message.success.delete', { name: 'api-key' }), icon: 'check', type: 'success' }));
            this.$bus.$emit('closeModal');
          }).finally(() => {
            this.loading = false;
          });
        }
      });
    },
  },
};
</script>
